export const ALLOWED_REGIONS = ["us", "de", "jp"] as const;
export type Region = (typeof ALLOWED_REGIONS)[number];

let currentRegion: Region | null = null;

export const setRegion = (region: Region) => {
  currentRegion = region;
};

export const getRegion = (): Region | null => currentRegion;
